import React from "react";
import { Divider, ListItemText, Menu, MenuItem, Typography } from "@mui/material";

/**
 * Menú contextual estilo Illustrator (botón derecho sobre el lienzo).
 * Las acciones las resuelve el padre; aquí solo la lista según contexto.
 */
export default function MoodboardContextMenu({
  anchorPosition,
  open,
  onClose,
  items = [],
}) {
  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        anchorPosition
          ? { top: anchorPosition.y, left: anchorPosition.x }
          : undefined
      }
      slotProps={{
        paper: {
          sx: {
            minWidth: 220,
            maxWidth: 320,
            py: 0.5,
          },
        },
      }}
      MenuListProps={{ dense: true }}
    >
      {items.map((item, idx) => {
        if (item === "divider" || item?.type === "divider") {
          return <Divider key={`d-${idx}`} sx={{ my: 0.5 }} />;
        }
        if (item?.type === "label") {
          return (
            <Typography
              key={item.id || `l-${idx}`}
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", px: 2, py: 0.5 }}
            >
              {item.label}
            </Typography>
          );
        }
        return (
          <MenuItem
            key={item.id || `i-${idx}`}
            disabled={Boolean(item.disabled)}
            onClick={() => {
              onClose?.();
              item.onClick?.();
            }}
          >
            <ListItemText
              primary={item.label}
              secondary={item.shortcut || null}
              primaryTypographyProps={{ variant: "body2" }}
              secondaryTypographyProps={{
                variant: "caption",
                sx: { textAlign: "right" },
              }}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                m: 0,
                "& .MuiListItemText-secondary": { flexShrink: 0 },
              }}
            />
          </MenuItem>
        );
      })}
    </Menu>
  );
}
